import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./PaymentBanner.css";

function PaymentBanner({ paymentDetails, onDismiss }) {
  const navigate = useNavigate();

  if (!paymentDetails) return null;

  const {
    isPaid,
    amountPaid,
    amountDue,
    displayAmount: displayAmountFromDetails,
    totalAmount,
    amount,
    planType,
    installmentsTotal,
    installmentAmount,
    installmentsPaid,
  } = paymentDetails;

  // Use new backend fields if available, otherwise fall back to legacy fields
  // If isPaid === false, use amountDue/displayAmount (amount owed)
  // If isPaid === true, use amountPaid (amount already paid)
  const displayAmount = isPaid === false 
    ? (amountDue || displayAmountFromDetails || totalAmount || amount || 0)
    : (amountPaid || amount || 0);
  const displayTotalAmount = totalAmount || amountDue || displayAmountFromDetails || amount || 0;
  const displayInstallmentAmount = (installmentAmount && installmentAmount > 0) ? installmentAmount : 0;
  const displayInstallmentsTotal = (installmentsTotal && installmentsTotal > 0) ? installmentsTotal : 0;

  // Don't show banner if amount is 0 or invalid (unless isPaid is explicitly false)
  if (isPaid !== false && displayAmount === 0 && displayTotalAmount === 0) {
    console.warn("PaymentBanner: Invalid payment details - amount is 0", paymentDetails);
    return null;
  }

  const remainingPayments =
    displayInstallmentsTotal - (installmentsPaid || 0);

  const handleCompletePayment = () => {
    navigate("/payment");
  };

  return (
    <div className="payment-banner">
      <div className="payment-banner-content">
        <strong className="payment-banner-title">
          ⚠️ Payment Required
        </strong>
        <p className="payment-banner-message">
          Your payment plan needs to be completed.
          {/* "installment" was the monthly plan's former name. Left unchanged this
              branch stopped matching once the rows were renamed, and an unpaid
              monthly signup saw the whole annual figure as "Amount due" instead
              of their first payment and monthly rate. */}
          {(planType === "monthly" || planType === "installment") && displayInstallmentsTotal > 0 ? (
            <>
              {" "}
              First payment: <strong>${displayAmount.toFixed(2)}</strong> | Remaining:{" "}
              {remainingPayments} payments of ${displayInstallmentAmount.toFixed(2)}/month
            </>
          ) : (
            <>
              {" "}
              Amount due: <strong>${displayTotalAmount.toFixed(2)}</strong>
            </>
          )}
        </p>
      </div>
      <div className="payment-banner-actions">
        <button
          onClick={handleCompletePayment}
          className="payment-banner-button-primary"
        >
          Complete Payment
        </button>
        <button
          onClick={onDismiss}
          className="payment-banner-button-secondary"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

PaymentBanner.propTypes = {
  paymentDetails: PropTypes.shape({
    isPaid: PropTypes.bool,
    amountPaid: PropTypes.number,
    amountDue: PropTypes.number,
    displayAmount: PropTypes.number,
    totalAmount: PropTypes.number,
    amount: PropTypes.number,
    planType: PropTypes.string,
    installmentsTotal: PropTypes.number,
    installmentAmount: PropTypes.number,
    installmentsPaid: PropTypes.number,
  }),
  onDismiss: PropTypes.func.isRequired,
};

export default PaymentBanner;

